import { render } from "./Overlay.vue?vue&type=template&id=2cfc4c5a&ts=true"
import script from "./Overlay.vue?vue&type=script&lang=ts"
export * from "./Overlay.vue?vue&type=script&lang=ts"

import "./Overlay.vue?vue&type=style&index=0&id=2cfc4c5a&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__